var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.0904 15.0831C1.66946 15.0831 1.31315 14.9373 1.02148 14.6456C0.729818 14.354 0.583984 13.9977 0.583984 13.5767V2.42292C0.583984 2.00198 0.729818 1.64567 1.02148 1.354C1.31315 1.06234 1.66946 0.916504 2.0904 0.916504H13.2442C13.6651 0.916504 14.0214 1.06234 14.3131 1.354C14.6048 1.64567 14.7506 2.00198 14.7506 2.42292V13.5767C14.7506 13.9977 14.6048 14.354 14.3131 14.6456C14.0214 14.9373 13.6651 15.0831 13.2442 15.0831H2.0904ZM2.0904 13.8332H13.2442C13.3083 13.8332 13.3671 13.8064 13.4205 13.753C13.4739 13.6996 13.5006 13.6408 13.5006 13.5767V7.74338H1.83396V13.5767C1.83396 13.6408 1.86067 13.6996 1.91409 13.753C1.96752 13.8064 2.02629 13.8332 2.0904 13.8332ZM1.83396 6.49342H13.5006V2.42292C13.5006 2.35881 13.4739 2.30004 13.4205 2.24661C13.3671 2.19319 13.3083 2.16648 13.2442 2.16648H2.0904C2.02629 2.16648 1.96752 2.19319 1.91409 2.24661C1.86067 2.30004 1.83396 2.35881 1.83396 2.42292V6.49342ZM7.6673 4.66648H12.6673V2.99982H7.6673V4.66648Z",
    fill: "#233DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabs);
export default __webpack_public_path__ + "static/media/tabs.2228093d1e0e464abba7d54a02b056e6.svg";
export { ForwardRef as ReactComponent };